module.exports = __webpack_public_path__ + "img/cart-orange.466bcb3f.svg";